import { useTranslate } from '@tolgee/react';
import { Modal, ModalProps } from 'antd';
import WhatsAppTemplatePreview from 'components/WhatsAppTemplatePreview';
import { getLength, value2editorValue } from './WhatsAppEditor/ContentEditor';

function PreviewModal({
  template,
  ...otherProps
}: ModalProps & {
  template: Aide.WhatsAppTemplate;
}) {
  const { t } = useTranslate();

  return (
    <Modal
      title={t('预览')}
      width={258}
      footer={null}
      bodyStyle={{
        background: '#ddd',
      }}
      {...otherProps}
    >
      <WhatsAppTemplatePreview
        template={{
          header: template.header,
          contents: value2editorValue(
            getLength(template.translateContent) ? template.translateContent : template.content,
          ),
          footer: template.footer,
          buttons: template.buttons,
        }}
        assets={{
          pdfTitleText: t('ViewsChat.pdf第一页缩略图'),
          pdfNameText: t('ViewsChat.文件名'),
          contentPlaceholder: t('ViewsChat.输入后话术预览展示在这里'),
        }}
      />
    </Modal>
  );
}

export default PreviewModal;
